import { Corset } from '@marsinet/commons';

export interface EditPatientProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patient: any;
}

export enum PatientCorsetType {
  SmallFlat = 'Small Flat',
  SmallCurve = 'Small Curve',
  BigFlat = 'Big Flat',
  BigCurve = 'Big Curve',
}

export const corsetToTranslationKey: Record<PatientCorsetType, Corset> = {
  [PatientCorsetType.SmallFlat]: Corset.SMALL_FLAT,
  [PatientCorsetType.SmallCurve]: Corset.SMALL_CURVE,
  [PatientCorsetType.BigFlat]: Corset.BIG_FLAT,
  [PatientCorsetType.BigCurve]: Corset.BIG_CURVE,
};
